import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createHashHistory, createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { routeTree } from "./routeTree.gen";
import { store } from "./store/local-store";
import "./index.css";
import "@simble/fonts/finuslugi-fonts.css";
// biome-ignore lint/performance/noNamespaceImport: <Need for proper Sentry work>
import * as Sentry from "@sentry/react";
import { setupUnauthorizedInterceptor } from "@simble/shared/lib/axios-unauthorized-interceptor";
import { logout, refreshAuthToken } from "./services/finuslugi-auth";

Sentry.init({
  dsn: "https://5149cfaf7edcf625d26a739c9c3b2235@o4506044483633152.ingest.us.sentry.io/4510957783810048",
  environment: import.meta.env.VITE_ENVIRONMENT || "development",
  integrations: [Sentry.browserTracingIntegration()],
  // Set tracesSampleRate to 0.5 to capture 50%
  // of transactions for performance monitoring.
  // tracesSampleRate: 0.5,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", import.meta.env.VITE_SERVER_URI],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  // sendDefaultPii: true,
});

setupUnauthorizedInterceptor({ refreshAuthToken, logout, redirectUrl: "/#/invalid-token" });

const hashHistory = createHashHistory();

const router = createRouter({
  routeTree,
  history: hashHistory,
  context: { store },
});
const queryClient = new QueryClient();

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root") as HTMLElement;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider context={{ store }} router={router} />
      </QueryClientProvider>
    </StrictMode>
  );
}
